import {Tooltip as MantineTooltip} from '@mantine/core';

/**
 * Hover tooltip — design-layer pass-through over Mantine `Tooltip`.
 * @registry Pass-through Mantine Tooltip; import this instead of @mantine/core outside src/design.
 */
export const Tooltip = MantineTooltip;
